import { OIDCClient } from "./oidc-client";
import { POST_HEADERS } from "./common";
import { ReportAPIClient } from "@fundwave/openapi-client";
import { ReportCategory } from "@fundwave/openapi-client/dist/models";

class ReportAPI {
  static async saveReports(payload) {
    const saveReportServiceUrl = `${localStorage.getItem("team")}/services/openapi/report`;
    await fetch(saveReportServiceUrl, { headers: await OIDCClient.prepareHeaders(POST_HEADERS), body: JSON.stringify(payload) });
  }

  static async getReportTypes(fundId?: string) {
    let reportTypes = await ReportAPIClient.getReportTypes(undefined, undefined, ReportCategory.Functions);

    if (fundId) {
      const fundSpecificReportTypes = await ReportAPIClient.getReportTypes([+fundId], undefined, ReportCategory.Functions);
      reportTypes = reportTypes.concat(fundSpecificReportTypes);
    }

    return reportTypes;
  }

  static async uploadFile(file: File) {
    const uploadFileServiceURl = `${localStorage.getItem("team")}/services/api/file/upload`;

    const fileData = new FormData();
    fileData.append("file", file, file.name);

    const headers = await OIDCClient.prepareHeaders({
      "Accept": "application/json"
    });

    if ("Content-Type" in headers) {
      delete headers["Content-Type"];
    }

    const response = await fetch(uploadFileServiceURl, {
      method: "POST",
      headers: new Headers(headers),   
      body: fileData
    });

    const data = await response.text();
    
    return data.split(":")[0];
  }

}

export { ReportAPI };
